import React from 'react';
import { Button } from 'carbon-components-react';
import { Add16, Delete16 } from '@carbon/icons-react';
// import './ArrayTemplate.css';

const RowTemplate = props => {
  return (
    <div className='form-item-array' key={props.key}>
      {props.items.length > 0 && (
        <div>
          <h6 className='form-array-title'>
            {props.schema.title}
            {props.uiSchema['ui:hint'] && (
              <p className='bx--label' style={{ display: 'block' }}>{props.uiSchema['ui:hint']}</p>
            )}
          </h6>
        </div>
      )}
      {props.items.map(element => {
        return (
          <div key={element.key} className='form-item-array-row'>
            {element.children}
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                className='bx--btn--ghost'
                hasIconOnly
                iconDescription='Borrar'
                tooltipAlignment='center'
                tooltipPosition='bottom'
                onClick={element.onDropIndexClick(element.index)}
              >
                <Delete16 aria-label='Delete' />
              </Button>
            </span>
          </div>
        );
      }
      )}
      {props.canAdd && (
        <div>
          <Button
            className='bx--btn bx--btn--ghost'
            iconDescription='Button icon'
            kind='ghost'
            onClick={props.onAddClick}
            renderIcon={Add16}
            tabIndex={10}
            size='small'
          >
            {props.uiSchema['ui:btnText']}
          </Button>
        </div>
      )}
    </div>
  );
};

export default RowTemplate;
